export default __webpack_public_path__ + "static/media/dallas.ae9aafe6.png";